module.exports = __webpack_public_path__ + "static/media/spinebuzz-5.5d0b99f0.jpg";